<template>
  <svg class="icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 7H7M21 7H17M7 7V6C7 4.34315 8.34315 3 10 3L14 3C15.6569 3 17 4.34315 17 6V7M7 7H17M5 10L6.55212 18.5367C6.81148 19.9631 8.05387 21 9.50373 21H14.4963C15.9461 21 17.1885 19.9631 17.4479 18.5367L19 10M10 17L9.5 11M14 17L14.5 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>